import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getDeviceFingerprint } from '@admin-panel/utils';
import { buildHeaders } from '@admin-panel/providers';
import type { IAuthState } from '../identity/types';
import { GATEWAY_API_URL } from '@admin-panel/config/env';

type SynqAuthState = { identity: IAuthState };

export function overrideFetchBaseQuery({ baseUrl = GATEWAY_API_URL }: { baseUrl?: string }) {
  return fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const { token, refreshToken } = (getState() as SynqAuthState).identity;
      return buildHeaders({
        headers,
        accessToken: token,
        refreshToken: refreshToken,
        deviceId: getDeviceFingerprint(),
        portalCode: 'erp',
        app: 'synq',
        skipAdminVendorHeader: true,
        extras: {
          'abs-referer': window.location.href,
          'page-referer': document.referrer,
          'x-lk-orgid': 'lyskraft',
        },
      });
    },
    credentials: 'same-origin',
    mode: 'cors',
  });
}
